import { render, staticRenderFns } from "./StandaloneObject.vue?vue&type=template&id=4c2fff3e&scoped=true&"
import script from "./StandaloneObject.vue?vue&type=script&lang=js&"
export * from "./StandaloneObject.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneObject.vue?vue&type=style&index=0&id=4c2fff3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2fff3e",
  null
  
)

export default component.exports